import { render, staticRenderFns } from "./ChildMinistry.vue?vue&type=template&id=df0c7520&"
import script from "./ChildMinistry.vue?vue&type=script&lang=js&"
export * from "./ChildMinistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports